import React from 'react'

const Index = ({placeholder,onChange,value,type,className}) => {
  return (
    <input placeholder={placeholder} value={value} type={type} onChange={onChange} className={`${className} rounded-lg border-2 border-[#C4C4C4] bg-white text-center text-black text-base font-bold focus:outline-[#181E4B] py-2`} />
  )
}

export default Index